import { Linkedin, Twitter, Globe, Mail, MapPin, Phone } from "lucide-react";

const FOOTER_LINKS = {
  Solutions: ["Iron Byte Bulk Marketplace", "Iron Byte Rapid (60-min delivery)", "Quality Assurance", "Analytics"],
  Services: ["ironLogistics", "Byte-Credit", "Trade Insurance", "Consulting"],
  Company: ["About Us", "Leadership", "Careers", "Contact"],
  Legal: ["Privacy Policy", "Terms of Service", "ISO Certifications", "Compliance"],
};

export function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-ib-steel/10 bg-ib-surface/30 pb-24 sm:pb-0">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <a href="#hero" className="flex items-baseline gap-0 mb-4">
              <span className="font-unbounded font-black text-2xl tracking-tighter text-ib-text">Iron</span>
              <span className="font-jetbrains font-bold text-2xl text-ib-blue">Byte</span>
            </a>
            <p className="font-manrope text-xs text-ib-text-muted leading-relaxed mb-4">
              Iron Byte Technology Pvt. Ltd.
              <br />
              From chaos to control. Steel meets software.
            </p>

            {/* Office Address */}
            <div className="flex items-start gap-2 mb-4">
              <MapPin className="w-3 h-3 text-ib-text-muted flex-shrink-0 mt-0.5" />
              <p className="font-manrope text-[11px] text-ib-text-muted leading-relaxed">
                537, Sector 6, Wave City,<br />
                Ghaziabad - 201015
              </p>
            </div>

            {/* Contact emails */}
            <div className="space-y-2 mb-5">
              <a
                href="mailto:ironbytetech@gmail.com"
                data-testid="footer-email-general"
                className="flex items-center gap-2 font-jetbrains text-[11px] text-ib-text-muted hover:text-ib-blue transition-colors"
              >
                <Mail className="w-3 h-3 flex-shrink-0" />
                ironbytetech@gmail.com
              </a>
              <a
                href="mailto:sales@ironbyte.in"
                data-testid="footer-email-sales"
                className="flex items-center gap-2 font-jetbrains text-[11px] text-ib-text-muted hover:text-ib-lime transition-colors"
              >
                <Mail className="w-3 h-3 flex-shrink-0" />
                sales@ironbyte.in
              </a>
              <a
                href="tel:+917000528933"
                data-testid="footer-phone-sales-1"
                className="flex items-center gap-2 font-jetbrains text-[11px] text-ib-text-muted hover:text-ib-blue transition-colors"
              >
                <Phone className="w-3 h-3 flex-shrink-0" />
                +91 70005 28933
              </a>
              <a
                href="tel:+919902702903"
                data-testid="footer-phone-sales-2"
                className="flex items-center gap-2 font-jetbrains text-[11px] text-ib-text-muted hover:text-ib-blue transition-colors"
              >
                <Phone className="w-3 h-3 flex-shrink-0" />
                +91 99027 02903
              </a>
            </div>

            <div className="flex gap-3">
              <a
                href="#"
                data-testid="footer-linkedin"
                className="p-2 rounded-lg border border-ib-steel/20 hover:border-ib-blue/40 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4 text-ib-text-muted hover:text-ib-blue" />
              </a>
              <a
                href="#"
                data-testid="footer-twitter"
                className="p-2 rounded-lg border border-ib-steel/20 hover:border-ib-blue/40 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-4 h-4 text-ib-text-muted hover:text-ib-blue" />
              </a>
              <a
                href="#"
                data-testid="footer-forums"
                className="p-2 rounded-lg border border-ib-steel/20 hover:border-ib-blue/40 transition-colors"
                aria-label="Industry Forums"
              >
                <Globe className="w-4 h-4 text-ib-text-muted hover:text-ib-blue" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-outfit font-semibold text-sm text-ib-text mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="font-manrope text-xs text-ib-text-muted hover:text-ib-blue transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-6 border-t border-ib-steel/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-manrope text-[11px] text-ib-text-muted">
            &copy; {new Date().getFullYear()} Iron Byte Technology Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="font-jetbrains text-[10px] text-ib-text-muted px-2 py-1 rounded border border-ib-steel/20">
              ISO 9001:2015
            </span>
            <span className="font-jetbrains text-[10px] text-ib-text-muted px-2 py-1 rounded border border-ib-steel/20">
              ISO 14001:2015
            </span>
            <span className="font-jetbrains text-[10px] text-ib-text-muted px-2 py-1 rounded border border-ib-steel/20">
              OHSAS 18001
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
